import { loadAbort } from "utilities/load-abort-axios.utility.ts"
import axios from "axios"

const API_URL = process.env.REACT_APP_API_URL

export const getAll = (endpoint) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  return {
    call: axios.get(
      `${API_URL}${endpoint}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const getByID = (endpoint, _id) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  return {
    call: axios.get(
      `${API_URL}${endpoint}/${_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const create = (endpoint, object) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  const formData = new FormData()

  for (var key in object) {
    if (key === "worksites") {
      for (var i = 0; i < object[key].length; i++) {
        formData.append(`worksites[${i}]`, object[key][i])
      }
      continue
    }

    formData.append(key, object[key])
  }

  return {
    call: axios.post(
      `${API_URL}${endpoint}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const createQR = (endpoint, object) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  const formData = new FormData()

  for (var key in object) {
    if (key === "worksites") {
      for (var i = 0; i < object[key].length; i++) {
        formData.append(`worksites[${i}]`, object[key][i])
      }
      continue
    }

    formData.append(key, object[key])
  }

  return {
    call: axios.post(
      `${API_URL}${endpoint}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
        responseType: "blob",
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const update = (endpoint, object) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  const formData = new FormData()

  for (var key in object) {
    if (key === "worksites") {
      for (var i = 0; i < object[key].length; i++) {
        formData.append(`worksites[${i}]`, object[key][i])
      }
      continue
    }

    if (key === "persons" || key === "vehicles") {
      formData.append(key, JSON.stringify(object[key]))
      continue
    }

    formData.append(key, object[key])
  }

  return {
    call: axios.put(
      `${API_URL}${endpoint}/${object._id}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const deleteByID = (endpoint, _id) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  return {
    call: axios.delete(
      `${API_URL}${endpoint}/${_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const patchSupplier = (endpoint, type, itemId) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  const formData = new FormData()

  if (type === "persons") {
    formData.append("personId", itemId)
  } else {
    formData.append("vehicleId", itemId)
  }

  return {
    call: axios.patch(
      `${API_URL}${endpoint}/${type}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}

export const toggleAccess = (endpoint, type, itemId) => {
  const controller = loadAbort()
  const token = localStorage.getItem("token")

  const formData = new FormData()

  if (type === "persons") {
    formData.append("personId", itemId)
  } else {
    formData.append("vehicleId", itemId)
  }

  return {
    call: axios.patch(
      `${API_URL}${endpoint}/${type}/active`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": `multipart/form-data`,
        },
      },
      {
        signal: controller.signal,
      }
    ),
    controller,
  }
}
